import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start justify-start my-6" }
const _hoisted_2 = { class: "input-label mb-6" }
const _hoisted_3 = { class: "uppercase" }
const _hoisted_4 = { class: "error-message" }

import { useField, Field } from 'vee-validate';


export default {
  __name: 'ResearchInLastMonths',
  setup(__props) {

const { value: referralValue } = useField('referralType');

const { value, errors, errorMessage } = useField('researchInLastMonths');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode("Ile badań "),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(referralValue)), 1),
      _createTextVNode(" miałaś/eś wykonanych w ciągu ostatnich 12 miesięcy i jakie okolice obejmowały? ")
    ]),
    _createVNode(_unref(Field), {
      as: "textarea",
      name: "researchInLastMonths",
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
      type: "text",
      placeholder: "Opisz jakie badania wykonywałaś/eś w ciągu ostatnich 12 miesięcy i jakie okolice obejmowały.",
      class: _normalizeClass(["min-h-[174px] max-w-[666px] w-full bg-white p-7 text-base font-roboto rounded-md !mt-0", {
                'border-[1px] border-error border-solid': _unref(errors).length,
                'border-none': !_unref(errors).length,
            }])
    }, null, 8, ["modelValue", "class"]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(errorMessage)), 1)
  ]))
}
}

}